const META_CACHE = new WeakMap();
const OPTION_REGEX = /^\:([a-z]+)\(([^\)]*)\)/;
const PLACEHOLDER_REGEX = /{([0-9]+)}/g;

function createMeta(literals) {
	let key = literals[0];
	const trans = [];
	for (let i = 1; i < literals.length; i += 1) {
		const literal = literals[i];

		const match = literal.match(OPTION_REGEX);
		if (match) {
			trans.push([
				match[1],
				JSON.parse(match[2]),
			]);
		} else {
			trans.push(null);
		}

		const cleanedLiteral = match ? literal.replace(OPTION_REGEX, '') : literal;
		key += `{${i - 1}}${cleanedLiteral}`;
	}

	return {
		key,
		fransforms: trans,
	};
}

export class I18n {
	constructor(cfg) {
		this.config(cfg);
	}

	config(cfg = {}) {
		this.messages = {};
		this.transformers = {};

		if (cfg.messages) this.messages = cfg.messages;
		if (cfg.transformers) this.transformers = cfg.transformers;
	}

	i18nArr(literals, ...values) {
		let meta = META_CACHE.get(literals);
		if (meta === undefined) {
			meta = createMeta(literals);
			META_CACHE.set(literals, meta);
		}

		const msgArr = [];
		const msg = this.messages[meta.key] || meta.key;
		let litStartIndex = 0;
		for (;;) {
			const match = PLACEHOLDER_REGEX.exec(msg);
			if (match === null) break;

			msgArr.push(msg.substring(litStartIndex, match.index));
			litStartIndex = match.index + match[0].length;
			const i = Number.parseInt(match[1], 10);

			let value = values[i];
			const trans = meta.fransforms[i];
			if (trans !== null) value = this::this.transformers[trans[0]](values[i], trans[1]);
			msgArr.push(value);
		}

		if (litStartIndex !== msg.length) msgArr.push(msg.substr(litStartIndex));

		return msgArr;
	}

	i18n(literals, ...values) {
		return this.i18nArr(literals, ...values).join('');
	}
}
